import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Scrollbar from 'react-scrollbars-custom';
import './MedalAtlas.scss';
import { DDEmpty } from '../../globalPageStatus';
import HTTP from '../../../script/service';
import AchieveItem from '../dsUserAchieve/AchieveItem';

class MedalAtlas extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      list: [], // 勋章列表
      current: null, // 当前选中的勋章
    };
  }

  componentDidMount() {
    this.getMedalList();
  }

  // 获取勋章列表
  getMedalList = () => {
    this.props.dispatch({
      type: 'change_atlas_loading',
      data: { atlasLoading: true },
    });
    const { ds } = this.props;
    HTTP._get_medal_v2_my({ uid: ds.uid })
      .then((res) => {
        if (res?.code === 200) {
          this.setState({ list: res.data });
        }
      })
      .finally(() => {
        this.props.dispatch({
          type: 'change_atlas_loading',
          data: { atlasLoading: false },
        });
      });
  };

  render() {
    const { atlasLoading } = this.props.base;
    const { list } = this.state;
    return (
      <div className="medal-atlas-wrap noSelect">
        <div className="medal-atlas-header">
          <div className="sub-title">
            <span className="icon" />
            <span className="title">勋章墙</span>
          </div>
        </div>
        <div className="medal-atlas-content">
          {list?.length ? (
            <Scrollbar>
              {list.map((item, index) => (
                <AchieveItem
                  key={index}
                  className="medal-atlas-item"
                  cover={item.titlePic}
                  name={item.name}
                />
              ))}
            </Scrollbar>
          ) : (
            !atlasLoading && (
              <DDEmpty description="暂无勋章" className="medal-atlas-empty" />
            )
          )}
        </div>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(MedalAtlas);
